import {
  titles,
  paragraphsLists,
  others
} from './constants';

export const textStylesSet = [
  ...titles,
  ...paragraphsLists,
  ...others
];



// WEBPACK FOOTER //
// ./src/containers/foundations/TextStyles/textStylesSet.js